import React, { DetailedHTMLProps, InputHTMLAttributes } from "react";

import classnames from "classnames";

type ModalFooterProps = {} & DetailedHTMLProps<
  InputHTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

const ModalFooter = React.forwardRef<HTMLDivElement, ModalFooterProps>(
  ({ children, className, ...props }, ref) => {
    const bodyStyle = classnames(
      className || "mt-4 bg-light-0 flex justify-end space-x-2 px-4 py-4 sm:p-5 rounded-b"
    );

    return (
      <div className={bodyStyle} {...props} ref={ref}>
        {children}
      </div>
    );
  }
);

export default React.memo(ModalFooter);
